import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { AlertTriangle } from 'lucide-react';

import { useApp } from '@/presentation/hooks/use-app.js';

interface Props {
    message?: string;
    onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: Props) {
    const { translate } = useApp();
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 8 }}>
            <AlertTriangle size={28} color="var(--mui-palette-error-main)" />
            <Typography color="error" variant="body1">
                {message ?? translate('errors.generic')}
            </Typography>
            {onRetry && (
                <Button variant="outlined" size="small" onClick={onRetry}>
                    {translate('common.refresh')}
                </Button>
            )}
        </Box>
    );
}
